import {memo, useCallback} from "react";

import { BinIcon } from "../../../components/icon/Icon";
import { ZENDESK_BUTTON_TYPES } from "./ZendeskButtonConstants";
import { ZendeskButtonStyled, ZendeskFixedButtonStyled } from "./styled/ZendeskFixedButtonStyled";
import {useZendeskContext} from "../zendeskContext";
import {useGTMEvent} from "../../GoogleTagManager/googleTagManagerHooks";

export const ZendeskButton = memo(({ children, iconFontSize = '32px', iconColor, type, ...props }) => {
    const { isWebWidgetInited, openWebWidget } = useZendeskContext();
    const { handleGTMClick } = useGTMEvent();

    const handleClick = useCallback(() => {
        openWebWidget();
        handleGTMClick({ button: 'ZendeskWebWidget' })
    },[handleGTMClick, openWebWidget])

    const ButtonStyled = type === ZENDESK_BUTTON_TYPES.fixed
        ? ZendeskFixedButtonStyled
        : ZendeskButtonStyled
    return (
        <ButtonStyled onClick={handleClick} disabled={!isWebWidgetInited} {...props}>
            <BinIcon name="IcQuestionMarkBubble" style={{ fontSize: iconFontSize, fill: iconColor }} />
            {children}
        </ButtonStyled>
    );
});